import { Calendar } from "./Calendar.model";

export interface Event {
    uid:         string;
    type:        string;
    id:          string;
    uidCalendar: string;
    uidCompany:  string;
    duration:    number;
    start:       string;
    end?:       string;
    status:      string;
    summary:     string;
    rating?:     number;
    recommendation?: string;
    guestName?:  string;
    createdBy:   string;
    responsibleId: string;
    responsibleName?: string;
    responsible?: { id: number, uid: string, name: string };
    participantIds: string[];
    participants?: { id: number, uid: string, name: string }[];
    creator_enriched?: any;
}

export interface User{
    name: string;
    uidUser: string;
    email: string;
}
export function mapToEvent(record: Record<string, any>): Partial<Event> {
    // Type guard to check if a value is string[]
    const isStringArray = (value: unknown): value is string[] => Array.isArray(value);
    const event = {} as Partial<Event>
    
    if(record.type != '' && typeof record.type != 'undefined')event.type= record.type as string;
    if(record.uid != '' && typeof record.uid != 'undefined')event.uid= record.uid as string;
    if(record.id != '' && typeof record.id != 'undefined')event.id= record.id as string;
    if(record.uidCalendar != '' && typeof record.uidCalendar != 'undefined')event.uidCalendar= record.uidCalendar as string;
    if(record.uidCompany != '' && typeof record.uidCompany != 'undefined')event.uidCompany= record.uidCompany as string;
    if(record.hour != '' && typeof record.hour != 'undefined' && record.minute != '' && typeof record.minute != 'undefined'){
        const hour = record.hour as string[]
        const minute = record.minute as string[]
        event.duration= ((parseInt(hour[1] as string) || 0)*60)+(parseInt(minute[1] as string) || 0);
    }
    if(record.start != '' && typeof record.start != 'undefined')event.start= record.start as string;
    if(record.end != '' && typeof record.end != 'undefined')event.end= record.end as string | undefined;
    if(record.status != '' && typeof record.status != 'undefined')event.status= record.status as string;
    if(record.summary != '' && typeof record.summary != 'undefined')event.summary= record.summary as string;
    const extra = record.extra_data && typeof record.extra_data === 'object' ? record.extra_data : {};
    const rating = record.rating ?? extra.rating;
    if (rating !== '' && rating != null && !Number.isNaN(Number(rating))) event.rating = Number(rating);
    const recommendation = record.recommendation ?? extra.recommendation;
    if (typeof recommendation === 'string' && recommendation.trim()) event.recommendation = recommendation.trim();
    const guestName = record.guest_name ?? extra.guest_name;
    if (typeof guestName === 'string' && guestName.trim()) event.guestName = guestName.trim();
    
    if(record.duration  != '' && typeof record.duration != 'undefined' )event.duration = parseInt(record.duration as string) || 0;
    if(record.createdBy != '' && typeof record.createdBy != 'undefined')event.createdBy= record.createdBy as string;
    
    // Mapping for Responsible
    const respObj = record.responsible;
    if (respObj && typeof respObj === 'object') {
        event.responsible = respObj;
        if (respObj.uid) event.responsibleId = respObj.uid;
        if (respObj.name) event.responsibleName = respObj.name;
    } else {
        const respId = record.responsibleId || record.responsible_id;
        if(respId != '' && typeof respId != 'undefined') event.responsibleId = respId as string;
        if(record.responsibleName != '' && typeof record.responsibleName != 'undefined') event.responsibleName = record.responsibleName as string;
    }

    // Mapping for Participants
    if (record.participants && Array.isArray(record.participants) && record.participants.length > 0) {
        event.participants = record.participants;
        event.participantIds = record.participants.map((p: any) => p.uid).filter(Boolean);
    } else {
        const partIds = record.participantIds || record.participant_ids;
        if(partIds != '' && typeof partIds != 'undefined') {
            event.participantIds = isStringArray(partIds) ? partIds : [partIds as string];
        } else {
            event.participantIds = [];
        }
    }

    if (record.context?.creator_enriched) {
        event.creator_enriched = record.context.creator_enriched;
    } else if (record.creator_enriched) {
        event.creator_enriched = record.creator_enriched;
    }
    
    console.log("Mapped Event:", event)
    return event;
}

export function mapToCalendar(record: Record<string, any>): Partial<Calendar> {
    // Type guard to check if a value is string[]
    //const isStringArray = (value: unknown): value is string[] => Array.isArray(value);
    const calendar = {} as Partial<Calendar>
    
    if(record.name != '' && typeof record.name != 'undefined')calendar.name= record.name as string;
    if(record.description != '' && typeof record.description != 'undefined')calendar.description= record.description as string;
    if(record.uidCalendar != '' && typeof record.uidCalendar != 'undefined')calendar.id= record.uidCalendar as string;
    if(record.createdBy != '' && typeof record.createdBy != 'undefined')calendar.createdBy= record.createdBy as string;
    
    // Explicit array checks
    if(record.customEvents && Array.isArray(record.customEvents)) calendar.customEvents = record.customEvents;
    else if(record.custom_events && Array.isArray(record.custom_events)) calendar.customEvents = record.custom_events;
    
    // Category mapping
    if(record.category != null && typeof record.category === 'string') calendar.category = record.category as any;
    
    return calendar;
}